/**
 * Cashier Method View
 */

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const tmpl = require('tmpl');
    const BaseView = require('common/base.view');
    const Form = require('class/form.class');
    const paymentUtil = require('common/payment.util');
    const user = require('user');
    const cfg = require('config');
    const core = require('core');
    const cashierUtil = require('modules/cashier/cashier.util');

    module.exports = BaseView.extend({

        tagName: 'li',

        className: 'info-list__row info-list__row_type_collapse payment-method fn-accordion',

        events: {
            'change .fn-change-account': 'addAnotherAccount',
            'change .fn-change-multi-field-account': 'handleChangeMultiFieldAccount'
        },

        defaultTemplateName: '',
        _genericTemplateName: 'payment.method.generic',
        _headerTemplateName: 'payment.method.header',

        render: function() {
            this.$el.html(this.template(this.model.toJSON()));

            this.form = new Form(this.$('form'), {
                validationConfig: this.model.get('config').validationConfig
            });

            return this;
        },

        template: function(data) {
            var templateName = this.defaultTemplateName;

            if (this.model.get('isGeneric')) {
                templateName = this._genericTemplateName;
            } else if (tmpl[templateName + '.' + this.model.id]) {
                templateName += '.' + this.model.id;
            } else if (this.model.get('config').creditCard) {
                templateName += '.creditCard';
            }

            if (data.name === 'BankTransferCH' && data._paymentType === 'withdraw') {
                data._userData = { ...user.get('userDetails') };

                var countryCode = data._userData.countryCode;
                var allowedCountries = cfg.get('allowedCountries');
                var userCountry = allowedCountries.filter(function(element) {
                    return element.code === countryCode;
                });

                data._userData.countryName = userCountry[0] && userCountry[0].name;
            }

            data = this.addIsHiddenField(data, true);
            data.currencyCode = user.get('currencyCode');
            data._methodHtml = this.tmpl(templateName, data);
            return this._headerTemplateName ? this.tmpl(this._headerTemplateName, data) : data._methodHtml;
        },

        addIsHiddenField: function(data) {
            var accountFields = data.accountFields?.field;
            var method = this.model.toJSON();

            if (!accountFields) {
                return data;
            }

            accountFields = _.map(accountFields, function(field) {
                field.isHiddenField = this.isHiddenField(field, method);
                return field;
            }.bind(this));

            data.accountFields.field = accountFields;

            return data;
        },

        isHiddenField: function(field /*, method */) {
            return field.isLabelField && !field.isAccountKey && !field.isRequired;
        },

        handleVCAccountChange: function(e) {
            var account = _.findWhere(this.model.get('account'), { code: e.target.value });
            var config = this.model.get('config');
            var data = _.extend(account, { config: config });

            this.model._prepareValidationConfig(data);
            this.form.setValidationConfig(data.config.validationConfig);
        },

        addAnotherAccount: function(e) {
            e.preventDefault();

            if (this.model.get('code') === 'VisaCheckout') {
                this.handleVCAccountChange(e);
                return;
            }

            this._clearAccountFields();

            var $fnAccountId = this.$('.fn-account-id:not(.fn-is-hidden-field)');
            var $fnIsHiddenField = this.$('.fn-is-hidden-field');
            var accountCode = e.target.value;

            if (e.target.value === 'add') {
                $fnAccountId.removeClass('hidden');
                $fnAccountId.find('input').removeAttr('disabled');

                $fnIsHiddenField.addClass('hidden');
                $fnIsHiddenField.find('input').attr('disabled', '');
            } else {
                $fnAccountId.addClass('hidden');
                $fnAccountId.find('input').attr('disabled', '');

                $fnIsHiddenField.removeClass('hidden');
                $fnIsHiddenField.find('input').removeAttr('disabled', '');
                this.setAccountFields(accountCode);
            }
        },

        handleChangeMultiFieldAccount: function(e) {
            var accountCode = e.target.value;

            e.preventDefault();

            this._clearAccountFields();

            if (accountCode === 'add') {
                return;
            }

            this.setAccountFields(accountCode);
        },

        /**
         * Fill form with account data
         * @param accountCode - account accountCode
         */
        setAccountFields: function(accountCode) {
            var account = this.model.findAccount(accountCode);

            if (!account || _.isEmpty(account.specificParams)) {
                return;
            }

            var selector = _.keys(account.specificParams).map(this._getInputSelectorByFieldName).join(',');
            this.form.data(account.specificParams);
            this.$(selector).attr('disabled', 'disabled');
        },

        _clearAccountFields: function() {
            var accountFields = this.model.get('accountFields').field;

            var selector = accountFields
                .map(function(field) {
                    return field.name;
                })
                .map(this._getInputSelectorByFieldName)
                .join(',');

            this.$(selector).removeAttr('disabled');
            this.form.clear(selector);
        },

        _getInputSelectorByFieldName: function(fieldName) {
            return '.field_name_' + fieldName + ' input';
        },

        performRedirect: function(response, paymentWindow) {
            var headerParams = paymentUtil.convertHeaderParameters(response.data.headerParameters);
            var isNeedPost = headerParams.method === 'POST' && headerParams.contentType
                && !_.isEmpty(headerParams.postData);

            paymentWindow = paymentWindow || window;

            if (isNeedPost) {
                var form = paymentUtil.createFormWithHeaderParameters(headerParams, null, paymentWindow.document);
                paymentWindow.document.body.appendChild(form).submit();
                return;
            }

            paymentWindow.location.href = headerParams.url;
        },

        /**
         * Handle specific IMS errors
         * @param  {Object} error
         * @return {Object|undefined}
         */
        handleError: function(error) {
            var knownErrors = [
                {
                    code: 'PAYMENTS-1012',
                    type: 'loseBonus'
                },
                {
                    code: 'PAYMENTS-1025',
                    type: 'feeConfirmed'
                },
                {
                    code: 'PAYMENTS-1027',
                    type: 'depositConfirmed'
                },
                {
                    code: 'PAYMENTS-1028',
                    type: 'currencyConversion'
                },
                {
                    code: 'PAYMENTS-1029',
                    type: 'profitTaxConfirmed'
                },
                {
                    code: 'PAYMENTS-1043',
                    type: 'beneficialOwnerConfirmed'
                }
            ];

            return error && _.find(knownErrors, function(knownError) {
                return knownError.code === error.code;
            });
        },

        /**
         * Handle specific IMS errors
         * @param  {Object} response
         * @return {Object|undefined}
         */
        handleActionableError: function(response) {
            const error = response.data.error;
            const content = cashierUtil.getErrorMessage(response);

            switch (error.code) {
                case 'PAYMENTS-1044':
                    window.Playtech.API.popup.showPopup({
                        title: 'playtech.mobile.system.mobile-cashier.error.title',
                        content
                    });

                    core.trigger('cashier:refresh', { id: this.model.id });
                    break;
            }
        }
    });
});
